<template>
  <div
    v-loading="loading"
    class="mt-track-compare"
  >
    <div class="mt-track-compare__item">
      <el-checkbox-button
        v-model="show"
        @change="toggle"
      >
        <r-icon
          name="chart-line"
          :size="18"
        />
        <span>
          {{ show ? 'Убрать сравнение' : 'Сравнить трек с другим ТС' }}
        </span>
      </el-checkbox-button>
    </div>
    <div
      v-if="show"
      class="mt-track-compare__item"
    >
      <el-select
        v-model="selectedTrackId"
        filterable
        @change="changeSecondTrackId"
      >
        <el-option
          v-for="item in vehicles"
          :key="item.id"
          :value="item.id"
          :label="item.reg_number"
        >
          {{ item.reg_number }}
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      loading: false,
      selectedTrackId: null
    }
  },
  computed: {
    vehicles() {
      return this.$store.state.monitoring.vehicles
    },
    selectedSecondTrackId() {
      return this.$store.state.monitoring.selectedSecondTrackId
    }
  },
  created() {
    if (this.selectedSecondTrackId) {
      this.show = true
      this.selectedTrackId = this.selectedSecondTrackId
    }
  },
  methods: {
    changeSecondTrackId(id) {
      if (!id) return

      this.$emit('change', id)
    },
    toggle() {
      this.selectedTrackId = null
      this.$emit('change', null)
    },
    clearCompare() {
      this.show = false
      this.selectedTrackId = null
    }
  }
}
</script>

<style lang="scss">
.mt-track-compare {
  display: flex;

  &__item {
    &:not(:first-child) {
      margin-left: 8px;
    }

    .el-checkbox-button {
      width: 208px;

      &__inner {
        display: flex;
        align-content: center;
        justify-content: center;
        width: 100%;
        height: 38px;
        line-height: 36px;
        border-radius: 4px !important;
        padding: 0 !important;
        background: transparent !important;
        border: none !important;
        color: var(--text_secondary) !important;

        .r-icon svg {
          fill: var(--text_secondary) !important;
        }

        span {
          margin-left: 8px;
        }
      }

      &.is-checked {
        .el-checkbox-button__inner {
          background: var(--accent_hover) !important;
          color: var(--accent_primary) !important;

          .r-icon svg {
            fill: var(--accent_primary) !important;
          }
        }
      }
    }

    .el-select {
      width: 200px;
    }
  }
}
</style>
